



































import Vue from 'vue';
import TitleComponent from './components/Title.vue'
import Spinner from '../components/Spinner.vue'
import BackgroundSpinner from './components/BackgroundSpinner.vue'
import SelectOn from './components/SelectOn.vue'
import Pagination from './components/Pagination.vue'
import TableComponent from './components/table/Table.vue'
import Toolbar from './components/toolbar/Toolbar.vue'
import DeleteModal from './components/dialogs/DeleteModal.vue'
import SettingsModal from './components/dialogs/SettingsModal.vue'
import ItemsModal from './components/dialogs/ItemsModal.vue'
import OrderService from './order.service'
import { Order, Orders, Settings, Response } from '../ordercall'

const orderService = new OrderService()

export default Vue.extend({
    data() {
        let orders: Orders = [];
        let settings: Settings = {};
        return {
            accountName: '',
            load: false,
            bgSpinner: false,
            deleteDialog: {
                status: false,
                order: null,
            },
            orders: orders,
            page: 1,
            count: 0,
            countAll: 0,
            countNew: 0,
            countOnPage: 1,
            statusselect: '0,1,2,3,4',
            order: "desc",
            sort: "create_datetime",
            date: {
                from: '',
                to: '',
            },
            datePeriod: 'alltime',
            countPeriod: {},
            settings: settings,
            items: {
                status: false,
                orderId: 0,
                data: []
            }
        }
    },
    watch: {
        countNew() {
            this.title()
            this.tabCount()
        }
    },
	created() {
        this.getOrders()
        setTimeout(() => {
            this.checkNew()
        }, 15000)
    },
    computed: {
        dateOutput(): string {
            if (!this.datePeriod) {
                if (!this.date.from || !this.date.to) {
                    return ''
                }
                return this.date.from + ',' + this.date.to
            }

            return this.datePeriod
        }
    },
	methods: {
        deleteOrder(order: Order) {
            this.bgSpinner = true
            var index = this.orders.indexOf(order, 0)
            if (index > -1) {
                this.orders.splice(index, 1)
            }
            this.deleteDialog.status = false
            orderService.deleteOrder(order.id).done((res: Response) => {
                this.getOrders()
            })
        },
        getOrders() {            
            orderService.getOrders(this.page, this.sort, this.order, this.statusselect, this.dateOutput, this.countOnPage).done((res: Response) => {
                this.accountName = res.data.account_name
                this.orders = res.data.orders
                this.page = res.data.page
                this.count = res.data.count
                this.countAll = res.data.count_all
                this.countNew = res.data.count_new
                this.countOnPage = res.data.count_on_page
                this.order = res.data.order
                this.sort = res.data.sort
                this.settings = res.data.settings
                this.countPeriod = res.data.count_period
                this.date = res.data.date
                setTimeout(() => {
                    this.load = true
                    this.bgSpinner = false
                }, 500)
            })
        },
        saveSettings(settings: Settings) {
            this.load = false
            this.statusselect = '0,1,2,3,4'
            this.datePeriod = 'alltime'
            this.countOnPage = settings.backend_count
            let date_from = this.date.from
            let date_to = this.date.to
            orderService.saveSettings(settings).done((res: Response) => {
                this.getOrders()
            })
        },
        setDate(date: string, end: boolean) {
            this.datePeriod = ''
            if (end) {
                this.date.to = date
            } else {
                this.date.from = date
            }
        },
        setStatus(order: Order, status: number) {
            if (order.status == 0) {
                this.countNew -= 1
            }
            order.status = status
            orderService.setStatus(order.id, status).done((res: Response) => {
                if (!+this.settings.backend_status_1) {
                    var index = this.orders.indexOf(order, 0)
                    if (index > -1) {
                        this.orders.splice(index, 1)
                    }
                    this.getOrders()
                }
            })
        },
        setPage(page: number) {
            this.bgSpinner = true
            this.page = page
            $('html, body').animate({
                scrollTop: 0
            },500);
            this.getOrders()
        },
        title() {
            let title: string = 'Обратный звонок'
            if (this.accountName) {
                title += ' — ' + this.accountName
            }
            if (this.countNew > 0) {
                title = `(${this.countNew}) ${title}`
            }

            document.title = title
        },
        tabCount() {
            let tab = $('li.shop-plugin__li.selected a sup')
            if (this.countNew > 0) {
                tab.show()
                tab.text(this.countNew)
            } else {
                tab.hide()
            }
        },
        checkNew() {
            orderService.getNewCount(this.countNew).done((res: Response) => {
                if (+res.data.offset) {
                    this.getOrders()
	                this.title()
                    this.tabCount()
                }
                setTimeout(() => {
                    this.checkNew()
                }, 15000)
            })
        },
        openItems(order: Order) {
            this.items.orderId = order.id
            orderService.getItems(order.id).done(((res: Response) => {
                this.items.data = res.data.items
            }))
        }
    },
    updated() {
        $("a[href='#']").on('click', function(e) {
            e.preventDefault();
        });
    },
    components: {
        TitleComponent,
        SelectOn,
        Toolbar,
        Pagination,
        TableComponent,
        DeleteModal,
        SettingsModal,
        ItemsModal,
        Spinner,
        BackgroundSpinner
    }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/webpack/vue/backend/Backend.vue